<template>
   <div class="mian_page">
       <div class="desktop-element">
           <div class="page flex-col">
               <my-menu class="sticky-menu" :default-active-index="0"></my-menu>
               <home-banner class="home-banner" :banners="bannerList" ></home-banner>
               <div class="div_content">
                   <home-about :imageUrl="aboutImageUrl"></home-about>
                   <ChpcValues :background-images-prop="valuesList"></ChpcValues>
                   <home-main :datalist="datalist"></home-main>
               </div>
               <ChpcFooter></ChpcFooter>
               <contact-float v-show="isVisible" @change="change" />
               <contact-dialog v-show="!isVisible" @showContact="showContact"></contact-dialog>
           </div>
       </div>
       <div class="mobile-element">
           <div class="mobile-page flex-col">
               <mobile-header class="sticky-menu-mobile" :default-active-index="0"></mobile-header>
               <div class="mobile-link">
                   <mobile-link :default-active-index="0"></mobile-link>
                   <mobile-banner></mobile-banner>
                   <mobile-about style="margin-top: 10px"></mobile-about>
               </div>

               <mobile-value></mobile-value>
               <mobile-core></mobile-core>
               <mobile-server ></mobile-server>
               <mobile-honor style="margin-top: 20px"></mobile-honor>
               <div class="mobile-news-container" style="margin-top: 10px;margin-bottom: 20px">
                   <mobile-news :datalist="datalist" ></mobile-news>
                   <mobile-map></mobile-map>
               </div>

               <mobile-footer @contactMobile="contactMobile"></mobile-footer>
               <mobile-contact-dialog v-show="isVisibleMobile" @closeMobileContact="closeMobileContact"></mobile-contact-dialog>
           </div>
       </div>
   </div>

</template>
<script>
    import myMenu from "@/views/Component/ChpcMenu.vue";
    import ContactFloat from "@/views/Component/Contact.vue";
    import ContactDialog from "@/views/Component/ContactDialog";
    import ChpcValues from "@/views/Component/ChpcValues";
    import homeBanner from "./childPage/homeBanner";
    import homeAbout from "./childPage/homeAbout";
    import homeMain from "./childPage/homeMain";
    import ChpcFooter from "@/views/Component/ChpcFooter";
    import MobileHeader from "@/views/Component/MobileHeader";
    import MobileLink from "@/views/Component/MobileLink";
    import MobileBanner from "./childPage/MobileBanner";
    import MobileAbout from "./childPage/MobileAbout";
    import MobileFooter from "@/views/Component/MobileFooter";
    import MobileValue from "@/views/Component/MobileValue";
    import MobileHonor from "@/views/Component/MobileHonor";
    import MobileNews from "./childPage/MobileNews";
    import MobileMap from "./childPage/MobileMap";
    import MobileCore from "./childPage/MobileCore";
    import MobileServer from "./childPage/MobileServer";
    import MobileContactDialog from "@/views/Component/MobileContactDialog";
    import {isNull} from "../../common/testFun";
    import commonFun from "@/util/common.js";

    export default {
        name: "homeIndex",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司',
            meta:[{name: 'keyWords', content:'官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, CHPC起步于医药行业,中国医药行业内风险控制领域的服务提供商，提供渠道核查、合规核查、信息技术、管理咨询服务,上海分公司地址变更为:上海市黄浦区蒙自路757号平安滨江金融中心30层3001室'},
                {name:"robots",content:"官网，中国医药行业内风险控制领域的服务提供商"},
            ]
        },
        data() {
            return {
                isVisible:true,
                isVisibleMobile:false,
                datalist :{},
                bannerList: [require('../../assets/tempImg/banner01.png'),],
                aboutImageUrl: require('@/assets/index/chpc_home_about.jpg'),
                valuesList:{
                    group_10: require('@/assets/home/home_my_value_01.png'),
                    group_11: require('@/assets/home/home_my_value_02.png'),
                    group_12: require('@/assets/home/home_my_value_03.png'),
                    group_14: require('@/assets/home/home_my_value_04.png'),
                },
                mobileMenuShow : false,
            };
        },
        //ContactFloat
        components:{
            myMenu,homeBanner,ChpcValues,homeAbout,homeMain,ChpcFooter,ContactDialog,ContactFloat,
            MobileHeader,MobileLink,MobileBanner,MobileAbout,MobileFooter,MobileValue,MobileNews,MobileMap,MobileHonor,MobileCore,MobileServer,MobileContactDialog
        },
        mounted() {
            const meta = document.createElement('meta');
            meta.name = 'viewport';
            meta.content = 'width=device-width, initial-scale=1';
            document.head.appendChild(meta);
            this.getHomeNews();
            this.getPic();
        },
        methods: {
            change(){
                this.isVisible = false;
            },
            contactMobile(){
                this.isVisibleMobile = true;
            },
            closeMobileContact(){
                this.isVisibleMobile = false;
            },
            showContact(){
                this.isVisible = true;
            },
            getHomeNews(){
                this.$HTTP.getHomeNews().then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        this.datalist = data;
                    }
                });
            },
            dealPic(data,funModel,isArr){
                if(data && data.length>0){
                    let picarr= data.filter(item => item.funModel === funModel);
                    if(picarr && picarr.length>0){
                        if(isArr){
                            let arr =[];
                            for(let i=0;i< picarr.length;i++){
                                arr.push(picarr[i].url);
                            }
                            return arr;
                        }else{
                            return picarr[0].url;
                        }
                    }
                }
            },
            //处理价值图片
            dealValuePic(data,funModel){
                if(data && data.length>0){
                    let picarr= data.filter(item => item.funModel === funModel);
                    if(picarr && picarr.length>0){
                      let group_10 = picarr.filter(item => item.orderNum === 1);
                      let group_11 = picarr.filter(item => item.orderNum === 2);
                      let group_12 = picarr.filter(item => item.orderNum === 3);
                      let group_14 = picarr.filter(item => item.orderNum === 4);
                      if(group_10 && group_10.length>0){
                          this.valuesList.group_10 = group_10[0].url;
                      }
                      if(group_11 && group_11.length>0){
                          this.valuesList.group_11 = group_11[0].url;
                      }
                      if(group_12 && group_12.length>0){
                            this.valuesList.group_12 = group_12[0].url;
                      }
                      if(group_14 && group_14.length>0){
                            this.valuesList.group_14 = group_14[0].url;
                      }
                    }
                }
            },
            getPic(){
                let pic ={model:1}
                let that = this;
                this.$HTTP.getPicByModel(pic).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        if(data && data.length>0){
                           let picarr= commonFun.dealPic(data,1,true);
                           if(picarr && picarr.length>0){
                               this.bannerList = picarr;
                           }
                           let aboutImg = commonFun.dealPic(data,2,false);
                           if(!isNull(aboutImg)){
                               this.aboutImageUrl = aboutImg;
                           }
                            that.dealValuePic(data,3);

                        }
                    }
                });
            }
        }
    };
</script>
<style scoped lang="css" src="./css/index.css" />
